import associate from './associate.json';
import online from './online.json';
import recipients from './recipients.json';

export default {
  associate,
  online,
  recipients,
};
